module.exports = __webpack_public_path__ + "static/media/chefpic-logo.ce637f05.png";